import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import { CORE_DOUGHNUT_MAPPING } from '@/constants';
import { useChartTooltip } from '@/hooks';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, formatPercentage, DoughnutChart } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CollateralShareChart({ type }) {
  const [data, error] = useApi({
    url: '/groups/share/'
  });
  const theme = useTheme();
  const navigate = useNavigate();
  const customTooltip = useChartTooltip(
    data,
    'group_name',
    'debt_share',
    false,
    'debt'
  );

  if (error) {
    throw error;
  }

  const chartData = useMemo(() => {
    if (data) {
      return {
        labels: data.map((row) => row.group_name),
        backgroundColor: data.map((row) =>
          collateralColorPalette(
            row.group_name,
            theme.colors.collateralColors,
            0.55
          )
        ),
        colorsBorder: data.map((row) =>
          collateralColorPalette(row.group_name, theme.colors.collateralColors)
        ),
        datasets: [
          {
            data: data.map((row) => row[`${type}_share`]),
            hoverOffset: 30
          }
        ]
      };
    }
    return null;
  }, [data, theme, type]);

  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 1.8,
        layout: {
          padding: 10
        },
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            enabled: false,
            position: 'nearest' as const,
            external: customTooltip
          }
        }
      }
    }),
    [customTooltip]
  );

  if (data) {
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        paddingTop="m"
        width="100%"
        height="100%">
        <DoughnutChart
          // @ts-ignore
          config={customConfig}
          data={chartData}
          valueFormatter={formatPercentage}
          url="/collateral"
          mapping={CORE_DOUGHNUT_MAPPING}
          navigate={navigate}
        />
      </Flex>
    );
  }
  return <ChartSkeleton type="doughnut" paddingTop="m" />;
}
